import Vue from 'vue'

export const getGoogleAuthUrl = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get('google-url')
      .then(
        (response) => {
          resolve(response.text())
        },
        (response) => {
          reject()
        }
      )
  })
}

export const getGoogleAuthCode = (url) => {
  return new Promise((resolve, reject) => {
    let _oauthWindow = window.open(url, 'Connexion Google', 'location=0,status=0,width=500,height=400')
    let interval = setInterval(function () {
      // HACK Catch security errors, it's awful but hey, it works...
      // The browser won't le me access children window url on an other domain (google)
      // Also throw error if different protocol between windows ( https != http )
      try {
        if (_oauthWindow.location.hash) {
          let code = _oauthWindow.location.search.replace('?code=', '')
          window.clearInterval(interval)
          _oauthWindow.close()
          resolve(code)
        }
      } catch (e) {
        // SShhh
      }
      if (_oauthWindow.closed) {
        window.clearInterval(interval)
      }
    }, 100)
  })
}

export const getGoogleAuthToken = (code) => {
  return new Promise((resolve, reject) => {
    Vue.http.post('google-token', { code })
    .then(
      (response) => {
        resolve(response.text())
      },
      (response) => {
        reject(response.json())
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/utils/googleAuth.js